export default {
  baseUrl: 'https://huhang.jinxinzhucan.com/api/'
}



// WEBPACK FOOTER //
// ./src/router/url.js